import { openTab } from './open-tab';
const DEFAULT_POPUP_PARAMS = {
  toolbar: false,
  location: false,
  directories: false,
  status: false,
  menubar: false,
  scrollbars: true,
  resizable: true,
  copyhistory: false
};
export function openPopup(url, width, height, onClose) {
  if (width === void 0) {
    width = 980;
  }
  if (height === void 0) {
    height = 600;
  }
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  const params = {
    ...DEFAULT_POPUP_PARAMS,
    width,
    height,
    top,
    left
  };
  openTab(url, params, '_blank', onClose);
}
//# sourceMappingURL=open-popup.js.map